export default __webpack_public_path__ + "static/media/Mohit Agrawal.c213106d.webp";